// ** Icons Import
import { useSkin } from "@hooks/useSkin";
import { Heart } from "react-feather";

const USDCLogo = require("@src/assets/images/the-club/asset/usdc.svg").default;
const ATLASLogo =
  require("@src/assets/images/the-club/asset/atlas.svg").default;
const ATLASLogoDark =
  require("@src/assets/images/the-club/asset/atlas_dark.svg").default;

const Footer = () => {
  const [skin] = useSkin();
  return (
    <p className="clearfix mb-0 d-flex">
      <span className="ml-0 d-block d-md-inline-block mt-25">
        COPYRIGHT © {new Date().getFullYear()}{" "}
        <a
          href="https://discord.gg/the-sa-club"
          target="_blank"
          rel="noopener noreferrer"
        >
          The Club
        </a>
        <span className="d-none d-sm-inline-block">, All rights Reserved</span>
      </span>
      <span className="mt-25 m-auto-ni d-none d-xl-block">
        Support us (donate): 3d7EhHREZxkxqjdCDC8aYipoJH9FNms31foGPTTeHWxc
        <img
          src={skin === "light" ? ATLASLogoDark : ATLASLogo}
          alt="atlas"
          width="14px"
          style={{ marginLeft: "4px" }}
        />
        <img
          src={USDCLogo}
          alt="usdc"
          width="18px"
          style={{ marginLeft: "4px" }}
        />
        <img
          src="https://raw.githubusercontent.com/solana-labs/token-list/main/assets/mainnet/So11111111111111111111111111111111111111112/logo.png"
          width="18"
          height="18"
          style={{ marginLeft: "4px" }}
        />
      </span>
      <span className="mr-0 d-none d-md-block mt-25 m-max-xl-auto">
        {"Hand-crafted & Made with"}
        <Heart size={14} />
      </span>
    </p>
  );
};

export default Footer;
